module.exports = __webpack_public_path__ + "img/ynmj.656b29f7.png";